export enum Material {
  NONE_MATERIAL = 'none',
  BRUSHED_MATERIAL = 'brushed',
  FACETED_MATERIAL = 'faceted'
}

export const MATERIALS_ORDER = [
  Material.NONE_MATERIAL,
  Material.BRUSHED_MATERIAL,
  Material.FACETED_MATERIAL
]